/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import EnvelopeWithBox from '../components/EnvelopeWithBox';
import MipServicing from '../components/MipServicing';

//SQC-647 Jacques Bega
//HUD MIP servicing UI page
const PmiServicingPage: React.FC = () => {
  return (
    <EnvelopeWithBox blockName='MIP Servicing'>
      <MipServicing />
    </EnvelopeWithBox>
  );
};

export default PmiServicingPage;
